/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Box, Grid } from '@material-ui/core';
import { useNavigate, useLocation } from '@reach/router';
const { selectDesktop } = Slices.appSlice;
const { selectCurrentCountry, addNumber, getProfile } = Slices.profileSlice;
const { selectCountryValidations } = Slices.configSlice;
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
// import { Badge } from '../../components/Icons';
import css from './index.module.scss';
import MobileNumberInput from '../Profile/MobileNumberInput';

function AddNumber() {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const dispatch = useDispatch();
  const isDesktop = useSelector(selectDesktop);
  const [profileNumber, setProfileNumber] = React.useState('');
  const [pageError, setPageError] = React.useState('');
  const countryName = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const cCode = countryValidations?.defaultCCode;

  const profileNumberChange = (e) => {
    setProfileNumber(e.target.value);
  };

  const addNewNumber = () => {
    const payload = {
      country: countryName,
      cCode: cCode,
      phnNo: profileNumber,
    };
    dispatch(addNumber(payload))
      .then((resp) => {
        if (resp.payload?.data?.type === 'DEFAULT_SUCCESS') {
          dispatch(getProfile());
          // navigate(-1);
          navigate(`/${intl.locale}/numberOtp`, {
            replace: true,
            state: {
              cCode: countryValidations?.defaultCCode,
              phnNo: profileNumber,
              otpId: resp.payload.data?.data?.otpId,
              oldLocation: location.state?.oldLocation || location,
              retUrl: location.state.retUrl || 'profile',
            },
          });
        } else {
          setPageError(resp.payload?.data?.message);
        }
      })
      .catch((error) => {
        setPageError(error?.message);
        console.log(error);
      });
  };
  return (
    <Grid>
      {!isDesktop ? (
        <Header
          title={<FormattedMessage id="profileAddNumberHeading" defaultMessage="Add Number" />}
          actionButtons={[<LanguageButton />]}
        />
      ) : (
        <div className={css.header}>
          {/* <div className={css.badge}>
            <Badge />
          </div> */}
          <div className={css.mainHeading}>
            <FormattedMessage id="profileAddNumberHeading" defaultMessage="Add Number" />
          </div>
        </div>
      )}

      <div className={css.main}>
        <Box className={css.profileBox}>
          <h3>
            You need to have a local mobile number to place an order in{' '}
            {countryValidations?.fullCountryName}.
          </h3>
          <Grid className={css.mobileIoArea}>
            <MobileNumberInput
              page="guest"
              countryCode={cCode}
              showCountryDropDown={false}
              value={profileNumber}
              onChange={profileNumberChange}
              hideName={true}
            />
          </Grid>
          {pageError !== '' && <Grid className={css.error}>{pageError}</Grid>}
          <Grid className={css.button}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              onClick={addNewNumber}
              disabled={!profileNumber.match(countryValidations?.phnRegex) || profileNumber === ''}
            >
              <FormattedMessage id="guest_save" defaultMessage="Save" />
            </Button>
          </Grid>
        </Box>
      </div>
    </Grid>
  );
}

export default AddNumber;
